import React, { useMemo, useState } from 'react';
import UI from '../../ui';
import contacts_db, { contact } from '../../data/contacts_db';

const Contact: React.FC<{ contact: contact, added: boolean, onClick: () => void, onRemove: () => void }> = ({ contact, added, onClick, onRemove }) => {
  const imageUrl = `./contacts/${contact.userName}.jpeg`;
  return (
    <UI.HorizontalLayout justify="space-between">
      <UI.HorizontalLayout gap={10}>
        <img
          src={imageUrl}
          style={{
            width: '40px',
            height: '40px',
          }}
        />
        <UI.VerticalLayout justify="center">
          <UI.Text size="subtitle" weight="bold">{contact.userName}</UI.Text>
          <UI.Text>{contact.name}</UI.Text>
        </UI.VerticalLayout>
      </UI.HorizontalLayout>
      <UI.HorizontalLayout gap={10}>
        <UI.Button
          label={added ? 'Added' : 'Add'}
          icon={added ? undefined : 'add'}
          type="tertiary"
          onClick={onClick}
        />
        <UI.IconButton
          name="close"
          disabled={added}
          onClick={onRemove}
        />
      </UI.HorizontalLayout>
    </UI.HorizontalLayout>
  );
};

const AddContactsStep: React.FC = () => {
  const [searchText, setSearchText] = useState('');
  const [addedContacts, setAddedContacts] = useState<contact[]>([]);
  const [ignoredContacts, setIgnoredContacts] = useState<contact[]>([]);
  const addContact = (contact: contact) => {
    setAddedContacts(prev => [...prev, contact]);
  };
  const unAddContact = (contact: contact) => {
    setAddedContacts(prev => prev.filter(({ userName }) => userName !== contact.userName));
  };
  const removeContact = (contact: contact) => {
    setIgnoredContacts(prev => [...prev, contact]);
  };
  const searchStr = searchText.toLowerCase();
  const contacts = useMemo(() =>
    contacts_db
      .filter(({ userName }) => !ignoredContacts.some(c => c.userName === userName))
      .filter(({ name, userName }) => name.toLowerCase().includes(searchStr) || userName.toLowerCase().includes(searchStr)),
  [ignoredContacts, searchStr]);

  return (
    <React.Fragment>
      <UI.VerticalLayout gap={15} width="100%">
        <UI.VerticalLayout>
          <UI.Text size="title" weight="bold">Add Friends</UI.Text>
          <UI.Text>Find your friends</UI.Text>
        </UI.VerticalLayout>
        <UI.Textfield
          label=""
          placeHolder="Find Friends"
          startIcon="search"
          endAdornment={<UI.IconButton name="import_contacts" onClick={() => {}} />}
          onChange={setSearchText}
          value={searchText}
        />
        <UI.Text weight="bold">Quick Add</UI.Text>
      </UI.VerticalLayout>
      <UI.VerticalLayout overflow="scroll" gap={10} width="100%">
        {contacts.map((contact, i) => {
          const added = addedContacts.some(({ userName }) => contact.userName === userName);
          const onClick = added ? unAddContact : addContact;
          return <Contact key={i} contact={contact} added={added} onClick={() => onClick(contact)} onRemove={() => removeContact(contact)} />;
        })}
      </UI.VerticalLayout>
    </React.Fragment>
  );
};

export default AddContactsStep;
